<section
  *ngIf="{
    isLayoutHidden: isLayoutHidden$ | async,
    isWindowAtTop: isWindowAtTop$ | async,
    isHandset: isHandset$ | async,
    closeHandsetSidebarOnRouteChange: closeHandsetSidebarOnRouteChange$ | async,
    onToggleMenu: onToggleMenu$ | async
  } as State"
  class="content-wrapper"
>
  <mat-toolbar
    #toolbar
    *ngIf="!State.isLayoutHidden && State.isHandset"
    color="secondary"
    class="mat-elevation-z6 flex"
  >
    <toolbar (toggleMenu)="drawer()?.toggle()"></toolbar>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav
      *ngIf="!State.isLayoutHidden"
      class="sidenav"
      [ngClass]="isSidenavCollapsed ? 'sidenav--collapsed' : ''"
      fixedInViewport
      [attr.role]="State.isHandset ? 'dialog' : 'navigation'"
      [mode]="State.isHandset ? 'over' : 'side'"
      [opened]="State.isHandset || State.isLayoutHidden ? false : true"
      [style.margin-top.px]="toolbarHeight"
    >
      <a [routerLink]="'/'" class="sidenav__nci-logo">
        <img [lazyLoad]="'assets/images/cdilogo.png'" alt="DGI logo" />
      </a>

      @if (isSandboxEnvironment) {
        <div class="ribbon">Sandbox</div>
      }

      <div class="sidenav__menu">
        <mat-list class="sidenav__menu-links">
          <ng-container *ngFor="let link of sidebarLinks">
            <ng-container *ngxPermissionsOnly="link.permissions ?? []">
              <div *ngIf="link.sectionTitle" class="sidenav__title-wrapper">
                <span class="sidenav__title">
                  {{ link.sectionTitle }}
                </span>
              </div>

              <a
                mat-list-item
                [routerLink]="link.enabled !== false ? link.url : undefined"
                [class.sidenav__menu-item--disabled]="link.enabled === false"
                [routerLinkActive]="
                  link.enabled !== false ? 'mdc-list-item--active' : ''
                "
                [routerLinkActiveOptions]="{
                  exact: link.exactActive ?? false
                }"
                [matTooltip]="link.tooltip || link.label"
                matTooltipPosition="after"
                (click)="link.enabled === false && $event.preventDefault()"
              >
                <mat-icon
                  class="mdc-list-item__icon"
                  [svgIcon]="'dgi-' + link.icon"
                  color="primary"
                ></mat-icon>
                <span class="mdc-list-item__label">{{ link.label }}</span>
                <!-- <small *ngIf="link.hasBadge" class="badge">4</small> -->
              </a>
            </ng-container>
          </ng-container>
        </mat-list>
      </div>
      <div class="sidenav__menu-card">
        <div class="sidenav__menu-card-icon-wrapper">
          <span class="sidenav__menu-card-icon">?</span>
        </div>

        <p class="sidenav__menu-card-title">Besoin d'aide ?</p>
        <p class="sidenav__menu-card-description">
          Des difficultés avec la plateforme ? Veuillez consulter la
          documentation pour plus d'informations
        </p>
        <a
          href="https://docs.fneci.net"
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          >Documentation</a
        >
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <main
        class="content-wrapper__content"
        [style.padding-top.px]="
          !State.isLayoutHidden && State.isHandset ? 0 : toolbarHeight
        "
      >
        <toolbar *ngIf="!State.isLayoutHidden"></toolbar>
        <div class="content-wrapper__content-main">
          <router-outlet></router-outlet>
        </div>

        <admin-footer></admin-footer>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</section>
